import YellowVelvetTop from "./YellowVelvetTop.png"
import PinkCrochetTop from "./PinkCrochetTop.png"
import StripedTerryTop from "./StripedTerryTop.png"
import TexturedBlueTop from "./TexturedBlueTop.png"
import ArmyGreenTop from "./ArmyGreenTop.png"
import BlackVelvetTop from "./BlackVelvetTop.png"
import BlueVelvetTop from "./BlueVelvetTop.png"
import LimeGreenTop from "./LimeGreenTop.png"
import PinkCrochetOneShoulderTop from "./PinkCrochetOneShoulderTop.png"
import PinkTexturedTop from "./PinkTexturedTop.png"
import StripedVelvetTop from "./StripedVelvetTop.png"
import StripedScoopTop from "./StripedScoopTop.png"
import BlackVelvetBottoms from "./BlackVelvetBottoms.png"
import BlueTexturedBottoms from "./BlueTexturedBottoms.png"
import GreyBottoms from "./GreyBottoms.png"
import LimeGreenBottoms from "./LimeGreenBottoms.png"
import PatteredBottoms from "./PatternedBottoms.png"
import PinkCrochetBottoms from "./PinkCrochetBottoms.png"
import PinkPatteredBottoms from "./PinkPatternedBottoms.png"
import PurpleGlitterBottoms from "./PurpleGlitterBottoms.png"
import PurpleTexturedBottoms from "./PurpleGlitterBottoms.png"
import RedBottoms from "./RedBottoms.png"
import StripedBottoms from "./StripedBottoms.png"
import YellowCrochetBottoms from "./YellowCrochetBottoms.png"
import GreyScoop from "../Assets/GreyScoop.png"
import RedScoop from "../Assets/RedScoop.png"
import PrintedBandeau from "../Assets/PrintedBandeau.png"
import TexturedBlue from "../Assets/TexturedBlue.png"
import PurpleGlitter from "../Assets/PurpleGlitter.png"
import PurpleBandeau from "../Assets/PurpleBandeau.png"
import Printed from "../Assets/Printed.png"
import OrangeCrochet from "../Assets/OrangeCrochet.png"
import BlueCrochet from "./BlueCrochet.png"
import YellowVelvet from "./YellowVelvet.png"
import GreenSparkle from "./GreenSparkle.png"
import OrangePattern from "./OrangePattern.png"

let all_product = [
    {
        id:1,
        name: "Yellow Velvet Kini Top",
        category: "Tops",
        image: YellowVelvetTop,
        price: 40.00,
    },

    {
        id:2,
        name: "Pink Crochet Kini Top",
        image: PinkCrochetTop,
        category: "Tops",
        price: 40.00,
    },

    {
        id:3,
        name: "Striped Terry Kini Top",
        image: StripedTerryTop,
        category: "Tops",
        price: 40.00,
    },

    {
        id:4,
        name: "Textured Blue Kini Top",
        image: TexturedBlueTop,
        category: "Tops",
        price: 40.00,
    },

    {
        id:5,
        name: "Army Green Kini Top",
        image: ArmyGreenTop,
        category: "Tops",
        price: 40.00,
    },

    {
        id:6,
        name: "Black Velvet Kini Top",
        image: BlackVelvetTop,
        category: "Tops",
        price: 40.00,
    },

    {
        id:7,
        name: "Blue Velvet Kini Top",
        image: BlueVelvetTop,
        category: "Tops",
        price: 40.00,
    },
    
    {
        id:8,
        name: "Lime Green Kini Top",
        image: LimeGreenTop,
        category: "Tops",
        price: 40.00,
    },

    {
        id:9,
        name: "Pink Crochet One Shoulder Kini Top",
        image: PinkCrochetOneShoulderTop,
        category: "Tops",
        price: 40.00,
    },

    {
        id:10,
        name: "Pink Textured Kini Top",
        image: PinkTexturedTop,
        category: "Tops",
        price: 40.00,
    },

    {
        id:11,
        name: "Striped Velvet Kini Top",
        image: StripedVelvetTop,
        category: "Tops",
        price: 40.00,
    },

    {
        id:12,
        name: "Striped Scoop Kini Top",
        image: StripedScoopTop,
        category: "Tops",
        price: 40.00,
    },

    {
        id:13,
        name: "Black Velvet Kini Bottoms",
        image: BlackVelvetBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:14,
        name: "Blue Textured Kini Bottoms",
        image: BlueTexturedBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:15,
        name: "Grey Kini Bottoms",
        image: GreyBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:16,
        name: "Lime Green Kini Bottoms",
        image: LimeGreenBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:17,
        name: "Pattered Kini Bottoms",
        image: PatteredBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:18,
        name: "Pink Crochet Kini Bottoms",
        image: PinkCrochetBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:19,
        name: "Pink Pattered Kini Bottoms",
        image: PinkPatteredBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:20,
        name: "Purple Glitter Kini Bottoms",
        image: PurpleGlitterBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:21,
        name: "Purple Textured Kini Bottoms",
        image: PurpleTexturedBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:22,
        name: "Red Kini Bottoms",
        image: RedBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:23,
        name: "Striped Kini Bottoms",
        image: StripedBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:24,
        name: "Yellow Crochet Kini Bottoms",
        image: YellowCrochetBottoms,
        category: "Bottoms",
        price: 40.00,
    },

    {
        id:25,
        name: "Grey Scoop Kini",
        image: GreyScoop,
        category: "Best Sellers",
        price: 80.00,
    },

    {
        id:26,
        name: "Red Scoop Kini",
        image: RedScoop,
        category: "Best Sellers",
        price: 80.00,
    },

    {
        id:27,
        name: "Printed Bandeau Kini",
        image: PrintedBandeau,
        category: "Best Sellers",
        price: 80.00,
    },

    {
        id:28,
        name: "Textured Blue Kini",
        image: TexturedBlue,
        category: "Best Sellers",
        price: 80.00,
    },

    {
        id:29,
        name: "Purple Glitter Kini",
        image: PurpleGlitter,
        category: "Best Sellers",
        price: 80.00,
    },

    {
        id:30,
        name: "Purple Bandeau Kini",
        image: PurpleBandeau,
        category: "Best Sellers",
        price: 80.00,
    },

    {
        id:31,
        name: "Printed Kini",
        image: Printed,
        category: "Best Sellers",
        price: 80.00,
    },

    {
        id:32,
        name: "Orange Crochet Kini",
        image: OrangeCrochet,
        category: "Best Sellers",
        price: 80.00,
    },

    {
        id:33,
        name: "Blue Crochet Kini",
        image: BlueCrochet,
        category: "Best Sellers",
        price: 80.00,
    },

    {
        id:34,
        name: "Yellow Velvet Kini",
        image: YellowVelvet,
        category: "Best Sellers",
        price: 80.00,
    },

    {
        id:35,
        name: "Orange Pattern Kini",
        image: OrangePattern,
        category: "Best Sellers",
        price: 80.00,
    },

    {
        id:36,
        name: "Green Sparkle Kini",
        image: GreenSparkle,
        category: "Best Sellers",
        price: 80.00,
    },

];

export default all_product;